import { render, staticRenderFns } from "./technicalManageList.vue?vue&type=template&id=483ad9db&scoped=true"
import script from "./technicalManageList.vue?vue&type=script&lang=js"
export * from "./technicalManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483ad9db",
  null
  
)

export default component.exports